export default [
  {
    path: "vehicle-inspection-catalog",
    name: "VehicleInspectionCatalogLayout",
    component: () => import(/* webpackChunkName: "vehicle_inspection_catalog_layout" */ "@modules/VehicleInspection/views/catalog/Layout.vue"),
    meta: { requiresAuth: true, root: true, title: "vehicle_inspection_catalog_layout_title" },
    redirect: { name: 'VehicleInspectionCatalogBody' },
    children: [
      {
        path: "body",
        name: "VehicleInspectionCatalogBody",
        component: () => import(/* webpackChunkName: "vehicle_inspection_catalog_body" */ "@modules/VehicleInspection/views/catalog/Body.vue"),
        meta: { requiresAuth: true, title: "vehicle_inspection_catalog_body_title" }
      },
      {
        path: 'interior',
        name: 'VehicleInspectionCatalogInterior',
        component: () => import(/* webpackChunkName: "vehicle_inspection_catalog_interior" */ '@modules/VehicleInspection/views/catalog/Interior.vue'),
        meta: { requiresAuth: true, title: "vehicle_inspection_catalog_interior_title" }
      },
      {
        path: 'mechanical',
        name: 'VehicleInspectionCatalogMechanical',
        component: () => import(/* webpackChunkName: "vehicle_inspection_catalog_mechanical" */ '@modules/VehicleInspection/views/catalog/Mechanical.vue'),
        meta: { requiresAuth: true, title: "vehicle_inspection_catalog_mechanical_title" }
      },
      {
        path: 'tires-wheels'
        ,
        name: 'VehicleInspectionCatalogTiresWheels',
        component: () => import(/* webpackChunkName: "vehicle_inspection_catalog_tires_wheels" */ '@modules/VehicleInspection/views/catalog/TiresWheels.vue'),
        meta: { requiresAuth: true, title: "vehicle_inspection_catalog_tires_wheels_title" }
      },
      {
        path: 'documentation-accessories',
        name: 'VehicleInspectionCatalogDocumentationAccessories',
        component: () => import(/* webpackChunkName: "vehicle_inspection_catalog_documentation_accessories" */ '@modules/VehicleInspection/views/catalog/DocAccessories.vue'),
        meta: { requiresAuth: true, title: "vehicle_inspection_catalog_documentation_accessories_title" }
      }
    ]
  },

  {
    path: "vehicle-inspection",
    name: "VehicleInspectionLayout",
    component: () => import("@modules/VehicleInspection/views/inspections/Layout.vue"),
    meta: { requiresAuth: true, inventory: true, title: "vehicle_inspection_layout_title" },
    redirect: { name: 'VehicleInspectionList' },
    children: [
      {
        path: "inspections",
        name: "VehicleInspectionList",
        component: () => import("@modules/VehicleInspection/views/inspections/InspectionList.vue"),
        meta: { requiresAuth: true, title: "vehicle_inspection_list_title" }
      },
      {
        path: "inspections/status/:status",
        name: "VehicleInspectionListStatus",
        component: () => import("@modules/VehicleInspection/views/inspections/InspectionList.vue"),
        meta: { requiresAuth: true, title: "vehicle_inspection_list_title" }
      },
    ]
  },

  {
    path: "vehicle-inspection/inspections/:id",
    name: "VehicleInspectionDetails",
    component: () => import("@modules/VehicleInspection/views/inspections/InspectionDetails.vue"),
    meta: { requiresAuth: true, title: "vehicle_inspection_details_title" }
  }
];